/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-undef */
import styleVariablesJSON from '../css/styleVariables.json';

const jsonToCssVariables = (json) => {
  let css = '';
  for (const key in json) {
    if (key) {
      css += `--${key}: ${json[key]};`;
    }
  }
  return css;
};

export const setCssVariables = (json) => {
  const cssVariables = jsonToCssVariables(json);
  document.documentElement.style.cssText = cssVariables;
};

export const jsonToConstants = (json) => {
  const COLORS = {};
  for (const key in json) {
    COLORS[key] = json[key];
  }
  return COLORS;
};

export default jsonToConstants(styleVariablesJSON);
